var map = {
	"./core/CoreDrawer.vue": "50e0",
	"./core/CoreFilter.vue": "ba94",
	"./core/CoreToolbar.vue": "470b",
	"./core/CoreView.vue": "c35f",
	"./core/Footer.vue": "7a74",
	"./core/Test.vue": "d38d",
	"./core/UserButton.vue": "3fea",
	"./helper/Offset.vue": "c6cc",
	"./material/Card.vue": "e3a9",
	"./material/ChartCard.vue": "78d5",
	"./material/Notification.vue": "9d6c",
	"./material/StatsCard.vue": "42e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffe0";